module.exports = __webpack_public_path__ + "img/login_slide.47a72e17.png";